export enum AlertBannerBackgroundColor {
  PRIMARY = "primary",
  POSITIVE = "positive",
  NEGATIVE = "negative",
  DARK = "dark",
  WARNING = "warning"
}
